import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import {
  LEAD_DELIVERY_LABELS,
  PARTNER_STATUS_LABELS,
  getCategoryLabel,
  statusBadgeClass,
} from "../../../constants/automapPartnershipConstants";
import {
  archivePartner,
  fetchPartner,
  updatePartner,
} from "../../../services/automapPartnershipApi";
import { AdminPartnerDetailNav, usePartnerIdParam } from "./AdminPartnersShared";

export default function AdminPartnerDetailPage() {
  const partnerId = usePartnerIdParam();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setData(await fetchPartner(partnerId));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [partnerId]);

  useEffect(() => {
    load();
  }, [load]);

  const p = data?.partner;

  const togglePause = async () => {
    if (!p) return;
    const next = p.status === "active" ? "paused" : "active";
    await updatePartner(partnerId, { status: next });
    load();
  };

  const handleArchive = async () => {
    if (!window.confirm("¿Archivar aliado?")) return;
    await archivePartner(partnerId);
    load();
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Aliado"
        title={p?.name || "Aliado"}
        description={p ? getCategoryLabel(p.category) : ""}
        actions={p ? (
          <>
            <Link className="admin-link" to={`/admin/partners/${partnerId}/edit`}>Editar</Link>
            {" · "}
            <button type="button" className="admin-link" style={{ background: "none", border: "none", cursor: "pointer" }} onClick={togglePause}>
              {p.status === "active" ? "Pausar" : "Reactivar"}
            </button>
            {" · "}
            <button type="button" className="admin-link" style={{ background: "none", border: "none", cursor: "pointer" }} onClick={handleArchive}>Archivar</button>
          </>
        ) : null}
      />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnerDetailNav partnerId={partnerId} active="detail" />
      <main className="admin-console__main wrap">
        {loading ? <p>Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {p ? (
          <>
            <div className="admin-dashboard__metrics-grid">
              <div className="admin-dashboard__metric-card"><span>Leads mes</span><strong>{data.performance?.leads ?? 0}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Calificados</span><strong>{data.performance?.qualified ?? 0}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Entregados</span><strong>{data.performance?.delivered ?? 0}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Conv.</span><strong>—</strong></div>
            </div>
            <section className="dealer-state-box">
              <p><span className={statusBadgeClass(p.status)}>{PARTNER_STATUS_LABELS[p.status]}</span></p>
              <p>{p.publicDescription || p.description}</p>
              <p><strong>Ciudades:</strong> {(p.citiesServed || []).join(", ") || "—"}</p>
              <p><strong>Áreas:</strong> {(p.serviceAreas || []).join(", ") || "—"}</p>
              <p><strong>Prioridad routing:</strong> {p.routingPriority}</p>
              <p><strong>Entrega:</strong> {LEAD_DELIVERY_LABELS[p.leadDeliveryMethod]}</p>
              <p><strong>Contacto:</strong> {p.contactName} · {p.contactEmail} · {p.contactWhatsapp}</p>
              {p.complianceNotes ? <p><strong>Compliance:</strong> {p.complianceNotes}</p> : null}
            </section>
            <section className="dealer-state-box">
              <h3>Leads recientes</h3>
              {!data.recentLeads?.length ? <p className="muted">Sin leads.</p> : (
                <ul>{data.recentLeads.map((l) => (
                  <li key={l.id}><Link to={`/admin/partners/leads/${l.id}`}>{l.buyerName} — {l.status}</Link></li>
                ))}</ul>
              )}
            </section>
            <p className="muted">TODO: partner portal login, automated delivery, billing settlement.</p>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
